import { Button, InputSearch } from 'uikit'
import { useEffect, useRef, useState } from 'react'

export interface ListFilterProps {
  onChange: (state: FilterState) => void
}

export const ListFilter: React.FC<ListFilterProps> = ({ onChange }) => {
  const [state, setState] = useState<FilterState>({})
  const prevState = useRef<FilterState>(state)

  useEffect(() => {
    if (state !== prevState.current) {
      onChange(state)
      prevState.current = state
    }
  }, [state])

  const handleFilter = (value: FilterState) => {
    setState((state) => ({ ...state, ...value }))
  }

  const handleResetFilter = () => {
    setState({})
  }

  return (
    <>
      <InputSearch
        hideIcon
        label="clientId"
        value={state.clientId}
        onChange={(value: string) => handleFilter({ clientId: value })}
      />
      <Button size="sm" width="full" onClick={handleResetFilter}>
        Очистить фильтр
      </Button>
    </>
  )
}


export type FilterState = {
  clientId?: string
}